import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import RawHTML from '../common/RawHTML';
import {
	getLink,
} from '../../helpers/Event';
import {
	getTranslation,
} from '../../helpers/Technique';
import i18n from '../../i18n';

const Item = ({ event }) => {
	const { t } = useTranslation();

	const style = React.useMemo(() => {
		if (event && event.corner) {
			return {
				backgroundImage: `url(${event.corner})`,
			};
		}
		return null;
	}, [event && event.corner]);

	return <li className="events-item my-3 p-2 pb-5 border rounded" style={style}>
		<h3>
			<Link to={getLink(event)}>
				{(event.description && getTranslation(event.description, 'title', i18n.language))
					|| event.title}
			</Link>
		</h3>
		<div className="d-flex align-items-start justify-content-start">
			{event.start || event.end ?
				<div className="event-pane">
					{event.start ? <>
						<div><small>{t('events.start')}</small></div>
						<div className="mb-2">{moment(event.start).format('LL')}</div>
					</> : null}
					{event.end ? <>
						<div><small>{t('events.end')}</small></div>
						<div className="mb-2">{moment(event.end).format('LL')}</div>
					</> : null}
				</div>
			: null}
			{event.description?
				<div>
					<RawHTML
						html={getTranslation(event.description, 'description', i18n.language)}
					/>
				</div>
			: null}
		</div>
	</li>;
};

Item.propTypes = {
	event: PropTypes.shape({
		corner: PropTypes.string,
		description: PropTypes.shape({
		}),
		end: PropTypes.string,
		id: PropTypes.number,
		name: PropTypes.string,
		start: PropTypes.string,
		title: PropTypes.string,
	}),
};

export default Item;
